import { render, staticRenderFns } from "./true-false-generic.vue?vue&type=template&id=1aa51d3a"
import script from "./true-false-generic.vue?vue&type=script&lang=js"
export * from "./true-false-generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports